import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static outlets = ['structure-card'];

  static get targets() {
    return ['radio', 'card', 'magnify', 'example', 'empty', 'form'];
  }

  connect() {
    document.querySelectorAll('ion-radio').forEach((radioGroup) => {
      radioGroup.addEventListener('click', (e) => {
        this.filterOptions();
      });
    });
  }

  filterOptions() {
    let options = {};
    document
      .querySelectorAll('ion-radio-group')
      .forEach((radioGroup, index) => {
        radioGroup.querySelectorAll('ion-radio').forEach((radio) => {
          if (
            radio.classList.contains('ion-activated') ||
            radio.classList.contains('radio-checked')
          ) {
            options[radio.name.split('[')[1].split(']')[0]] = radio.value;
          }
        });
      });
    this.structureCardOutlets.forEach((structure) => {
      structure.filter(options);
    });

    const isHidden = (card) => card.isHidden();
    if (this.structureCardOutlets.every(isHidden)) {
      this.emptyTarget.classList.remove('hide');
    } else {
      this.emptyTarget.classList.add('hide');
    }
  }

  reset() {
    this.formTarget.reset();
    this.formTarget
      .querySelectorAll('ion-radio-group')
      .forEach((radioGroup) => {
        radioGroup.value = null;
        radioGroup.querySelectorAll('ion-radio').forEach((radio) => {
          radio.classList.remove('radio-checked');
        });
      });
    this.filterOptions();
  }

  magnifyTargetConnected() {
    this.setUpDialog('magnify');
  }

  exampleTargetConnected() {
    this.setUpDialog('example');
  }

  setUpDialog(type) {
    const fsDialog = document.querySelector('ion-modal#magnifyDialog');

    const fsDialogContent = document.getElementById(
      'fullscreen-dialog-content'
    );

    if (type == 'magnify') {
      this.magnifyTargets.forEach((button) => {
        button.addEventListener('click', () => {
          fsDialogContent.innerHTML = `<img src="${button.dataset.magnify}" style="width: 100%"/>`;
          fsDialog.isOpen = true;
        });
      });
    } else {
      this.exampleTargets.forEach((button) => {
        button.addEventListener('click', () => {
          fsDialogContent.innerHTML = `<img src="${button.dataset.example}" style="width: 100%"/>`;
          fsDialog.isOpen = true;
        });
      });
    }

    fsDialog.addEventListener('ionModalDidDismiss', (e) => {
      fsDialog.isOpen = false;
    });
  }
}
